import * as groupsActions from '../actions/groups.actions';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { update, remove } from '../../../shared/store/crud-functions';

export interface GroupsState {
    groups: any;
    loading: boolean;
    loaded: boolean;
    updateSuccess: boolean;
    addSuccess: boolean;
    error: any;
    deleteSuccess: boolean;
}

const initialState = {
    groups: null,
    loading: false,
    loaded: false,
    updateSuccess: null,
    addSuccess: null,
	error: null,
    deleteSuccess: null,
};

export const groupsReducer = (state = initialState, action) => {
    switch (action.type) {
        case groupsActions.GET_GROUPS_LIST:
            return {
                ...state,
                error: null,
                loading: true,
                loaded: state.loaded
            };
        case groupsActions.GET_GROUPS_LIST_SUCCESS:
            return {
                ...state,
                groups: action.payload,
                error: null,
                loading: false,
                loaded: true,
            };
        case groupsActions.GET_GROUPS_LIST_FAIL:
            return {
                ...state,
                error: action.payload,
                loading: false,
                loaded: false
            };
        case groupsActions.UPDATE_GROUP_SUCCESS:
            const group = action.payload;
            const groups = update(state.groups, group, 'bGroupId');
            return {
                ...state,
                groups: groups,
                error: null,
                loading: state.loading,
                loaded: state.loaded,
                updateSuccess: true
            };
        case groupsActions.UPDATE_GROUP_FAIL:
            return {
                ...state,
                error: action.payload,
                updateSuccess: false
            }
        case groupsActions.ADD_GROUP_SUCCESS:
            const newGroup = action.payload;
            return {
                ...state,
                error: null,
                groups: [newGroup, ...state.groups],
                addSuccess: true
            }
        case groupsActions.ADD_GROUP_FAIL:
            return {
                ...state,
                addSuccess: false,
                error: action.payload
            }

        case groupsActions.DELETE_GROUP_SUCCESS:
            const deletedGroup = action.payload;
            const deletedGroups = remove(state.groups, deletedGroup, 'id');
            return {
                ...state,
                groups: deletedGroups,
                loading: state.loading,
                loaded: state.loaded,
                deleteSuccess: true
            };

        case groupsActions.RESET_GROUP_CRUD:
            return {
                ...state,
                error: null,
                updateSuccess: null,
                deleteSuccess: null,
                addSuccess: null
            }

        case groupsActions.CLEAR_GROUPS_LIST:
            return {
                ...state,
                error: null,
                groups: null,
                loading: false,
                loaded: false
            };
        default:
            return state;
    }
};

export const getGroupsState = createFeatureSelector<GroupsState>('groupsReducer');

export const getGroupsList = (state: GroupsState) => state.groups;
export const getGroupsListLoaded = (state: GroupsState) => state.loaded;
export const getGroupUpdateStatus = (state: GroupsState) => state.updateSuccess;
export const getGroupAddNewStatus = (state: GroupsState) => state.addSuccess;
export const getGroupDeleteStatus = (state: GroupsState) => state.deleteSuccess;
export const getUnassignedGroupCount = (state: GroupsState) =>
  state.groups ?
    state.groups.filter(x => x.buildingCount === 0).length :
    0;
